import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import service from "../config.json";
import { mainAxios } from "../app/api";
import { errorToast, successToast } from "../helpers/toaster";
const { contact, contactCMS } = service;

const initialState = {
    loading: false,
    inquery: false,
    contactData: [],
};

export const GetContactAsync = createAsyncThunk(
    "contact/contact",
    async (state, { rejectwithvalue }) => {
        try {
            const res = await mainAxios.get(contactCMS);

            return res.data;
        } catch (err) {
            return rejectwithvalue(err.response.data);
        }
    }
);

export const contactUsAsync = createAsyncThunk(
    "contact/contactUsAsync",
    async ({ state }) => {
        var datas = {
            firstName: state.FirstName,
            lastName: state.LastName,
            email: state.Email,
            countryCode: state.CountryCode,
            mobile: state.MobileNo,
            message: state.Meassage,
        };
        try {
            const res = await mainAxios.post(contact, datas);
            return res.data;
        } catch (err) {
            const { response } = err;
            return response.data;
        }
    }
);

export const ContactSlice = createSlice({
    name: "contact",
    initialState,
    reducers: {
        clearInquery: (state) => {
            state.inquery = false;
        },
    },
    extraReducers: {
        [contactUsAsync.pending]: (state) => {
            return {
                ...state,
                loading: true,
            };
        },
        [contactUsAsync.fulfilled]: (state, { payload }) => {
            if (payload?.success === true) {
                successToast(payload?.message);
                return {
                    ...state,
                    inquery: true,
                    loading: false,
                };
            } else {
                errorToast(payload?.message);
            }
        },
        [GetContactAsync.pending]: (state) => {
            return {
                ...state,
                loading: true,
            };
        },
        [GetContactAsync.fulfilled]: (state, { payload }) => {
            if (payload?.success === true) {
                return {
                    ...state,
                    contactData: payload?.data,
                    loading: false,
                };
            } else {
                errorToast(payload?.message);
            }
        },
    },
});

export const inqueryStatus = (state) => {
    return state.contact.inquery;
};

export const { clearInquery } = ContactSlice.actions;
export default ContactSlice.reducer;
